import React from "react";
import {
  GatsbyImage, getImage, ImageDataLike,
} from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";

export interface IGatsbyImageOrSvg {
    image: IContentfulImage & ImageDataLike,
    className?: string,
    loading: "lazy" | "eager",
    alt: string
}

export const GatsbyImageOrSvg: React.FC<IGatsbyImageOrSvg> = ({
  image,
  className = "",
  loading = "lazy",
  alt,
}) => {
  const imageData = getImage(image as ImageDataLike);
  const isSvg = image?.file.contentType === "image/svg+xml";
  return isSvg ? (
    <img
      className={className}
      loading={loading}
      src={image.file.url}
      alt={image.title || alt}
    />
  ) : (
    <GatsbyImage
      className={className}
      loading={loading}
      image={imageData!}
      alt={image.title || alt}
    />
  );
};
